import { createSelector } from "reselect";
import _ from "lodash";
export const getUsers = ({ Messenger_reducer }) => {
    return Messenger_reducer.users;
};
export const getRequesting = ({ Messenger_reducer }) => {
    return Messenger_reducer.requesting;
};
export const getGroups = ({ Messenger_reducer }) => {
    return Messenger_reducer.groups;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectAllAreas = ({ Messenger_reducer }) => {
    return Messenger_reducer.areas;
};
export const selectAllDepartments = ({ Messenger_reducer }) => {
    return Messenger_reducer.departments;
};
export const selectDept = createSelector(
    [ selectProfile],
    (profile = false) => {
        if(profile){
            return profile.departments
        }else return null
    }
);
export const selectAreas = createSelector(
    [ selectProfile],
    (profile = false) => {
        if(profile){
            return profile.areas
        }else return null
    }
);

export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["messenger"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectRegisteredUsers = 
    createSelector([
        getUsers,
        selectAllDepartments,
        selectAllAreas, selectAreas, selectDept
        ], (users, allDept = false, allAr = false , userAreas = false, userDepts = false) => {

    if (users === false || typeof users === "undefined" || users === null) {
        return [];
    }
     //get users belonging to logged in user areas & depts    
     let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
     let allDepartments = allDept && Object.values(allDept).map((e)=> { return e })
     
     if(userAreas === false){
         userAreas = allAreas
     }
     if(userDepts === false){
         userDepts = allDepartments
     }
     let validationArea = []
     let validationDept = []

     let regUsers = _.compact(
        Object.keys(users).map(e => {
            let refArray = []
            let deleted =
                _.get(users[e], "profile.deleted") || false;
            let areas = 
                _.get(users[e], "profile.areas") || null
            let departments = 
                _.get(users[e], "profile.departments") || null 

            if(areas === null ){
                validationArea = _.intersection(allAreas,userAreas)
            }else{
                validationArea = _.intersection(areas,userAreas)
            }

            if(departments === null){
                validationDept = _.intersection(allDepartments,userDepts)
            }else {
                validationDept = _.intersection(departments,userDepts)
            } 

            if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                refArray.push( users[e] )
                return {
                    name: `${_.get(users[e], "profile.first_name")} ${_.get(
                        users[e],
                        "profile.last_name"
                    )}`,
                    uid: _.get(users[e], "profile.uid")
                };
                    
            } else return null;
        })
    );
    regUsers = regUsers.filter(e => {
        if (e.deleted !== true) {
            return true;
        } else {
            return false;
        }
    });
    return regUsers.sort((a, b) => a.name.localeCompare(b.name));
});
export const selectGroup = createSelector([getGroups], groups => {
    if (groups === false || typeof groups === "undefined" || groups === null) {
        return [];
    }

    let regGroups = Object.keys(groups).map(e => {
        return groups[e];
    });
    return _.orderBy(regGroups, "most_recent_message.timestamp", ["desc"]);
});
